import { gql } from "graphql-tag";

export const query = gql`
  query InterestFilterDashboard($interestListId: ID!) {
    interestList(id: $interestListId) {
      id
      interestFilters {
        id
        label
        name
        type
      }
    }
    interestFilters {
      id
      label
      name
      type
    }
  }
`;

export const insertMutation = gql`
  mutation InsertInterestFilter($interestListId: ID!, $filterId: ID!) {
    addFilterToInterestList(interestListId: $interestListId, filterId: $filterId) {
      id
    }
  }
`;

export const deleteMutation = gql`
  mutation DeleteInterestFilter($interestListId: ID!, $filterId: ID!) {
    deleteFilterForInterestList(interestListId: $interestListId, filterId: $filterId) {
      id
    }
  }
`;
